import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Col, Row} from 'react-bootstrap';
import classnames from 'classnames';
import {connect} from 'react-redux';
import StaffList from './staff-list';
import {delinkUserOutlet} from '../../actions/outlet';


import Title from '../common/title';
import ConfirmPopup from '../common/confirm-popup';
import ArrowButton from '../common/button-arrow';
import noPhoto from '../../assets/img/no_photo.png';

import './store-details.css';
import Can from '../common/guards/can';
import t from '../../data/translations';

class MyStoreDetails extends Component {
  handler = (arg, id, stateValueBefore, stateValueAfter) => {
    this.setState({
      selectedDenominations: {
        ...this.state.selectedDenominations,
        [id]: stateValueAfter,
      },
      orderAmount: parseInt(this.state.orderAmount) + parseInt(arg),
      total: this.state.total - parseInt(arg),
      totalAmount: this.state.totalAmount + (parseInt(stateValueAfter) - parseInt(stateValueBefore)),
    });
  };
  smClose = (result) => {
    if (result) {
      this
        .props
        .dispatch(delinkUserOutlet(this.props.storeId));
    }
    this.setState({smShow: false});
  };
  renderMyRewards = () => {
    const {store} = this.props;

    let myRewards = '';

    let autoRedemption = 'No';
    let nextOrderAmount = '';
    let nextOrderDate = '';

    try {
      if (store['my-rewards'] && store['my-rewards']['auto-redemption'] === true) {
        autoRedemption = 'Yes';
        nextOrderAmount = store['my-rewards'].order['next-order-amount'];
        nextOrderDate = (
          <div>
            <div className="details-label">
              Next order date:
            </div>
            <div className="details-value">
              {store['my-rewards'].order['next-order-date'][0]}
            </div>
          </div>
        );
      } else if (
        store['my-rewards'] &&
        store['my-rewards'].order['potential-staff-reward-value'] !== undefined &&
        store.errors === undefined
      ) {
        nextOrderAmount = store['my-rewards'].order['potential-staff-reward-value'];
        nextOrderDate = (
          <ArrowButton
            arrow={{
              direction: 'right'
            }}
            className="pull-left"
            onClick={this.onOrderNowClicked.bind(this)}
            submit={false}
          >
            Order now
          </ArrowButton>
        );
      } else if (store['my-rewards']) {
        nextOrderAmount = store['my-rewards'].order['potential-staff-reward-value'];
        nextOrderDate = store.errors['not-enough'];
      }

      if (this.props.newOrderAmount) {
        nextOrderAmount = this.props.newOrderAmount;
      }

      if (store['pay-for-performance'] === 'Y') {
        myRewards = (
          <div className="rewards-info">
            <Can action="handle" subjectClass="staff_rewards">
              <Row>
                <Col lg={12}>
                  <hr className="clear"/>
                </Col>
              </Row>
              <Title
                actionButton={(
                  <Link to={'/staff-rewards'}>
                    <ArrowButton
                      arrow
                      block
                      permissions={{
                        action: 'handle',
                        subjectClass: 'staff_rewards'
                      }}
                      submit={false}
                    >
                      { t('staffRewards.manage') }
                    </ArrowButton>
                  </Link>
                )}
                mainTitle="Rewards info"
              />

              <Row className="mg-bottom-20">
                <Col lg={12}>
                  <div>
                    <span>
Outlet points earned since:
                      {' '}
                    </span>
                    <span>
                      {store['balance-start-date']}
                    </span>
                  </div>
                  <div>
                    <span>
                      {`${store['outlet-points']} points`}
                    </span>
                  </div>
                  <div className={classnames({hidden: !store.level})}>
                    <div>
                      <span>
Current store level:
                      </span>
                    </div>
                    <div>
                      <span>
                        {store.level}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={2} md={3}>
                  <img
                    alt="No voucher selected"
                    className="voucher-photo"
                    src={store['my-rewards'] ? store['my-rewards'].voucher.links.photo : ''}
                  />
                </Col>
                <Col lg={10} md={9}>
                  <div className="details-label">
                    Current voucher:
                  </div>
                  <div className="details-value">
                    {store['my-rewards'] ? store['my-rewards'].voucher.name : '-'}
                  </div>

                  <div className="details-label">
                    Auto redemption:
                  </div>
                  <div className="details-value">
                    {autoRedemption}
                  </div>

                  <div className="details-label">
                    Next order amount:
                  </div>
                  <div className="details-value">
                    {`${t('currency')}${nextOrderAmount}`}
                  </div>

                  {nextOrderDate}
                </Col>
              </Row>
            </Can>
          </div>
        );
      }
    } catch (e) {
      myRewards = '';
    }

    return myRewards;
  };
  renderStaffList = () => {
    const {fetched, relationships} = this.props;

    let renderedStafflist = '';
    const registeredStaffMembers = [];

    if (fetched && relationships) {
      relationships.staff_members.forEach((curr) => {
        if (curr.status === 'registered') {
          registeredStaffMembers.push(curr);
        }
      });

      renderedStafflist = (
        <Can action="handle" subjectClass="staff">
          <div className="relationships">
            <Row>
              <Col lg={12}>
                <hr className="clear"/>
              </Col>
            </Row>
            <Title
              actionButton={(
                <Link to={'/my-staff'}>
                  <ArrowButton
                    arrow
                    block
                    className="manage-staff"
                    submit={false}
                  >
                    Manage staff
                  </ArrowButton>
                </Link>
              )}
              mainTitle="Staff"
            />
            <Row>
              <Col lg={12}>
                <StaffList fetched fetching={false} staff={registeredStaffMembers}/>
              </Col>
            </Row>
          </div>
        </Can>
      );
    }

    return renderedStafflist;
  };

  constructor(props) {
    super(props);
    this.state = {
      rewardShow: false,
      orderAmount: '',
      total: 0,
      totalAmount: 0,
      smShow: false,
      orderShow: false,
      orderDisabled: false,
      selectedDenominations: {}
    };
    this.spinners = '';
  }

  componentWillReceiveProps(nextProps) {
    const {order} = nextProps;
    if (Object.keys(order).length) {
      this.setState({
        orderAmount: order.attributes['order-amount']
      });
    }
  }

  onDelinkClicked() {
    this.setState({smShow: true});
  }

  onOrderNowClicked() {
    this.setState({orderShow: true});
  }

  renderConfirmation(spinners) {
    return (
      <ConfirmPopup
        cancelLabel="Cancel"
        confirmDisabled={this.state.orderDisabled}
        confirmLabel="Confirm"
        header="Select your vouchers"
        onClose={this.orderClose}
      >
        <Row>
          <Col md={12}>
            <div>
              Please choose the denominations you would like to order your vouchers in.
            </div>
          </Col>
          <Col md={12}>
            <div>
              Once you click confirm the required number of points will be removed from
              your Staff points budget and your vouchers will be sent your store.
            </div>
          </Col>
          <Col md={12}>
            <Title>
              <div className="pull-left">
                Available Order Amount
              </div>
              <div className="pull-right">
                {this.state.orderAmount}
              </div>
            </Title>
          </Col>
          <Col md={12}>
            <Row>
              <Col className="text-left" md={4}>
                <span>
Denomination
                </span>
              </Col>
              <Col className="vcenter" md={4}>
                <span>
Quantity
                </span>
              </Col>
              <Col className="vcenter" md={4}>
                <span>
Total
                </span>
              </Col>
            </Row>
          </Col>
          {spinners}
          <Col md={12}>
            <Row className="summary-row">
              <Col className="text-left" md={4}>
                <span>
TOTAL
                </span>
              </Col>
              <Col className="vcenter" md={4}>
                {this.state.totalAmount}
              </Col>
              <Col className="vcenter" md={4}>
                {this.state.total}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="text-left" md={12}/>
        </Row>
      </ConfirmPopup>
    );
  }

  render() {
    const {store} = this.props;
    const {representative} = store;

    let repImage = noPhoto;
    try {
      if (representative.image) {
        repImage = representative.image;
      }
    } catch (e) {
      repImage = noPhoto;
    }

    return (
      <div className="store-details">
        <Row className="store-details-info">
          <Col className="rep-details" md={3}>
            <div className="store-details-info-rep">
              <h3 className="rep-title center-text store-details-info-rep-title">
                Your rep
              </h3>
              <img alt="Your rep" className="rep-image" src={repImage}/>
              {representative && (
                <div className="rep-name">
                  {`${representative['first-name'] || ''} ${representative['last-name'] || ''}`}
                </div>
              )}
            </div>
          </Col>
          <Col md={6} className="store-details-info-address">
            <h3>
              <div>
                <Title>
                  {store.name || ''}
                </Title>
              </div>
            </h3>
            <h4>
              <div>
                CUSTOMER NUMBER:
                {store['customer-number'] || ''}
              </div>
              <div>
                {store['address-2'] || ''}
              </div>
              <div>
                {store['address-3'] || ''}
              </div>
              <div>
                {store['address-1'] || ''}
              </div>
              <div>
                {store.town || ''}
              </div>
              <div>
                {store.county || ''}
              </div>
              <div>
                {store.eircode || ''}
              </div>
            </h4>
          </Col>
          <Col md={3} className="store-details-info-nav">
            <h4 className="store-details-info-nav-title">QUICK LINKS</h4>
            <div className="store-details-info-nav-seperator" />
            <Link to="/" className="store-details-info-nav-link">Home</Link>
            <Link to="/products" className="store-details-info-nav-link">Products/Brands</Link>
            <Link to="/tbc" className="store-details-info-nav-link">POR Deals</Link>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3} className="store-details-button-container">
            <ArrowButton
              arrow={false}
              className="pull-left"
              onClick={() => this.onDelinkClicked()}
              submit={false}
            >
              Remove store
            </ArrowButton>

            {this.state.smShow && (
              <ConfirmPopup onClose={this.smClose}>
                <p>
                  Are you sure you want to remove this store from your
                  <strong>
                    {' '}
                    ignite
                    {' '}
                  </strong>
                  account? If you select confirm, your request will be sent to the
                  <strong>
                    {' '}
                    ignite
                    {' '}
                  </strong>
                  administration team.
                </p>
              </ConfirmPopup>
            )}
          </Col>
        </Row>
        {this.renderMyRewards()}
        {this.renderStaffList()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store.store,
  relationships: state.store.relationships,
  fetched: state.store.fetched,
  fetching: state.store.fetching,
  newOrderAmount: state.store.newOrderAmount
});

export default connect(mapStateToProps)(MyStoreDetails);



// WEBPACK FOOTER //
// ./src/components/store-details/store-details.jsx